<template>
    <transition name="leaveLoader" :duration="{leave: 1000000}" >
        <div class="Loader"> 
            <video v-if="!store.state.appLoaded && !show" disableRemotePlayback disablePictureInPicture x-webkit-airplay="deny" muted playsinline ref="video_logo" src="/img/cut_logo.mp4"/>
            <div ref="progress" class="Loader-progress"></div>
            <div :style="`opacity: ${opacity};`" class="pourcent">
                <span :style="`transition-delay: ${randomMilli}s`">{{milliNumber}}</span>
                <span :style="`transition-delay: ${randomDeca}s`">{{decaNumber}}</span>
                <span :style="`transition-delay: ${randomUni}s`">{{uniNumber}}</span>
            </div>
        </div>
    </transition>
</template>
<script>

import WebFont from 'webfontloader';
import Store from '@/stores/store.js'
import TimelineMax from "gsap/TimelineMax";
import gsap from "gsap";
export default {
    name: 'Loader',

    data() {
        return {
            store: Store,
            loaded: 0,
            index: 1,
            ratioLoaded: 0,
            fontLoaded: false,
            tl: null,
            t0: performance.now(),
            t1: 0,
            show: this.$route.name === 'about',
            opacity: 0,
            tweenedNumber: 0,
            randomMilli: Math.round(Math.random()* 60)/10,
            randomDeca: Math.round(Math.random()* 60)/10,
            randomUni: Math.round(Math.random()* 60)/10
        }
    },

    created(){
        // Preload Fonts
        WebFont.load({
            custom: {
                families: ['gotik']
            },
            active:() => {
                this.loaded = 0.15;
                this.ratioLoaded = (Store.state.loaded*85/100) + this.loaded
                this.opacity = 1
            },
            inactive: () => {
                this.loaded = 0.15;
                this.ratioLoaded = (Store.state.loaded*85/100) + this.loaded
            }
        });
        document.fonts.ready.then(() => {
            this.fontLoaded = true 
            this.opacity = 1
            if(this.ratioLoaded === 1) {
                gsap.to(this, 1, {
                    tweenedNumber: Math.floor(Math.random() * (999 - 601 + 1) + 601)
                });
            }
        });
    },

    computed: {
        ComputedPourcent: function() {
            return Math.round(this.tweenedNumber).toString()
        },
       animatedNumber: function() {
            return this.ComputedPourcent.charAt(0)
        },
        smallerNumer: function() {
            if(this.ComputedPourcent.length == 2) return this.ComputedPourcent.charAt(1);
            if(this.ComputedPourcent.length > 2) return "00"
        },
        milliNumber: function() {
            return this.ComputedPourcent.charAt(0)
        },
        decaNumber: function() {
            if(this.ComputedPourcent.length > 1) return this.ComputedPourcent.charAt(1);
        },
        uniNumber: function() {
            if(this.ComputedPourcent.length > 2) return this.ComputedPourcent.charAt(2);
        },
        getRandom: function() {
            return Math.round(Math.random()* 30)/10
        },
    },

    mounted(){
        this.t1 = performance.now()
        this.tl = new TimelineMax({paused:true,ease: Power2.easeInOut,});
    },
    methods:{
        onFinnish(){
            this.tl.duration(1)
            setTimeout(() => {
                this.opacity = 0
            }, 800);
            setTimeout(() => {
                this.moveLogo()
                Store.state.fontLoaded = true;
                this.$el.classList.add('remove')
                Store.state.appLoaded = Store.state.transitionsLoaded && Store.state.fontLoaded;
                console.log('App Mount took ', Math.round(this.t1 - this.t0)/1000,"s");
                console.log('App Loaded took ', Math.round(performance.now() - this.t0)/1000,"s");
                console.groupEnd()
            }, 1200);
        },
        moveLogo() {
            if(!Store.isDesktop && !this.show){
                if(this.$route.name !== 'home' ){
                    TweenMax.to(this.$refs.video_logo, 1, { x: (Store.width - 80) /2, ease: Power4.easeInOut });
                }else{
                    TweenMax.set(this.$refs.video_logo, { x: 0 });
                }
            }
        }
    },
    watch: {
        'store.state.loaded': function(newVal){
            this.ratioLoaded = (Store.state.loaded*85/100) + this.loaded
            if(this.fontLoaded) {
                this.opacity = 1
                gsap.to(this, 1, {tweenedNumber: (newVal - 0.001)*1000
                });
            }
            else if(newVal == 1 ) {
                gsap.to(this, 1, {tweenedNumber: (newVal - 0.001)*1000
                });
            }
        },
        ratioLoaded: function(){
            this.tl.add ( 
                TweenMax.to(this.$refs.progress, 0.5, { 
                    scaleX: this.ratioLoaded, 
                    ease: Linear.easeInOut,
                })
            );
            this.tl.play()
            if(this.ratioLoaded == 1 ) this.onFinnish()
        },
    }
}
</script>


<style scoped lang="scss">
    .Loader{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        width: 100%;
        height: 100%;
        transition: z-index 0.1s linear 1.4s;
        transition-delay: 1.4s;

        .pourcent {
            color: black;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 50;
            transition: 0.3s ease-out opacity;

            span {
                font-size: 20vw;
                will-change: font-variation-settings;
                letter-spacing: -8px;
                width: 100%;
                line-height: 1.4;
                top: 0;

                @include respond-to(md){
                    font-size: 20vw;
                }

                &:nth-child(1)  {
                    animation: 6s ease-in-out 0s fontVariaton infinite;
                }

                &:nth-child(2) {
                     animation: 6s ease-in-out 0.75s fontVariaton infinite;
                }

                &:nth-child(3) {
                     animation: 6s ease-in-out 1.25s fontVariaton infinite;
                }
            }
        }
        
        @keyframes fontVariaton {
            0%   {font-variation-settings: "wght" 700, "wdth" 100;}
            20%   {font-variation-settings: "wght" 400, "wdth" 50;}
            40%   {font-variation-settings: "wght" 100, "wdth" 10;}
            60%   {font-variation-settings: "wght" 900, "wdth" 80;}
            80%   {font-variation-settings: "wght" 200, "wdth" 50;}
            100%   {font-variation-settings: "wght" 700, "wdth" 100;}
        }

        video {
            position: fixed;
            top: 70px;
            left: 90px;
            z-index: 10000;
            mix-blend-mode: difference;
            width: 155px;
            height: 69px;   

            @include respond-to(md){
                top: 0;
                left: 20px;
            }
        }

        @supports not (mix-blend-mode: difference) {
            video {
                display: none;
            }
        }

        &:after{
            content: "";

            position: absolute;
            bottom: 0;
            width: 100%;
            height: 100%;
            background-color: white;
            transform: scale(1, 1) translateZ(0);

            transform-origin: top left;
            transition: transform 1.4s $ease-out-quint;
        }

        &-progress{
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 1;
            height: 15px;
            width: 100%;
            background-color: color(black);
            transform: scale(0, 1) translateZ(0);
            transform-origin: top left;
            transition: 0.3s ease-out opacity;
            opacity: 1;
        }
    }

    .leaveLoader-leave-active {

        .Loader-progress{
            opacity: 0;
        }

    }

    .leaveLoader-leave-to{
        &:after{
            transition-delay: 0.2s;
            transform: scale(1, 0) translateZ(0);
        }
    }

    .isTouch {
        .Loader {
            video {
                top: 0;
                left: 20px;
            }
        }
    }
</style>
